import set from "@rill/set";
import moment from "moment";
import RpeTable from "./RpeTable";
import _ from "lodash";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const RpeReport = (app) => {
  app.get(
    "/rpe-report",
    set("heading", "RPE Table"),
    async ({ req, res, load, locals }) => {
      const { query = {} } = req;
      const { from, to, primary, type, secondary } = query;

      const athleteId = locals.athlete
        ? locals.athlete._id
        : locals.activeUser._id;

      const isAllowToViewAllOrganizationsAthletes =
        locals.organizationRoleName &&
        (locals.organizationRoleName === "Owner" ||
          locals.organizationRoleName === "Admin");

      if (
        locals.activeUser.organizationId &&
        isAllowToViewAllOrganizationsAthletes &&
        !locals.allAthletesFromOrganization
      ) {
        await load("allAthletesFromOrganization");
      }

      await load("exerciseHistory", {
        primary: primary ? primary : "squat",
        type: type ? type : "primary",
        secondary: secondary ? secondary : "",
        proxyAthlete: athleteId,
        from: from
          ? moment.utc(from).toDate()
          : moment.utc(moment().subtract(6, "months")).toDate(),
        to: to ? moment.utc(to).toDate() : moment.utc(moment()).toDate(),
      });
      const modal = _.get(query, "modal", {});
      locals.modal = {
        "activity-feed": <ActivityDrawer />,
      }[modal.type];
      res.body = <RpeTable locals={locals} />;
    }
  );
};

export default RpeReport;
